import { isAliciaEnabledForProfile, type AliciaProfile } from '@sdx/b2o-fe-tools/featureFlags';
import { useGetData } from '../services/apiClient';
import { useAuth } from '../contexts/AuthContext';

/**
 * Whether the mobile Alicia button is offered, using the shared gate from `@sdx/b2o-fe-tools`
 * (same rule as the Alicia module's chatbot and the Navigation module's menu entry).
 */
export const useIsAliciaEnabled = (): boolean => {
  const { isFullyAuthenticated, flags } = useAuth();
  const baseUrl = import.meta.env.VITE_FOUNDATION_API_BASE_URL as string;

  // Same URL + query key as useLanguagePreference, so both read one cached /v1.0/profile response.
  const { data } = useGetData<AliciaProfile>(
    { url: `${baseUrl}/v1.0/profile`, queryKey: 'languagePreference' },
    { enabled: isFullyAuthenticated },
  );

  return isAliciaEnabledForProfile(data, flags);
};
